import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../redux/cartActions';
import map from 'lodash/map';
import memoize from 'lodash/memoize';
import {Table, Thead, Th, Tr, Td} from 'reactable';
import TableSupplier from './tableElements/TableSupplier';
import TableItemQuantity from './tableElements/TableItemQuantity';
import styles from './CartItemsTable.scss';
import {formatCartItemText} from 'src/logic/utils.js';
import {Button} from '../../Common/reactstrap/lib';
import deleteIcon from 'src/imgs/delete-icon.svg';
import InlineSVG from 'react-svg-inline';
import {formatPriceText as fpt} from 'src/logic/utils';

import EditableField from '../../Common/EditableField'

//todo refactor all the table
//(DRY, SSoT violations, e.g. column names hardcoded everywhere)

const renderTableHeader = memoize(() => (
  <Thead>
  <Th column="Наименование">
    Наименование
  </Th>
  <Th column="Описание">
    Описание
  </Th>
  <Th column="Комментарий">
    Комментарий
  </Th>
  <Th column="Поставщик">
    Поставщик
  </Th>
  <Th column="Срок, дн.">
    Срок, дн.
  </Th>
  <Th column="Кол-во, шт.">
    Кол-во
  </Th>
  <Th column="Цена" className={styles.price}>
    Цена <span className="price">&#8381;</span>
  </Th>
  <Th column=" "/>
  </Thead>
));


export class CartItemsTable extends Component {

  render() {
    const {
      changeCartItemQuantity,
      removeCartItem,
      changeItemComment
    } = this.props.actions;
    const tableRows = map(this.props.items, ({
                                               cartId,
                                               brandName,
                                               detailArticle,
                                               detailName,
                                               comment,
                                               deliveryTerms,
                                               logo,
                                               quantity,
                                               oldPrice,
                                               price,
                                               addDate,
                                               rating,
                                               partion,
                                               changeDate,
                                               state,
                                               offer
                                             }, i) => (
      <Tr key={`cartitemstablerow_${i}`}>
        <Td column="Наименование" style={{width: '15%'}}>
          <span>
            {brandName} <br/><a href={`search?article=${detailArticle}`} className="link">{detailArticle}</a>
          </span>
        </Td>
        <Td column="Описание" style={{width: '22%'}}>
          {formatCartItemText(detailName)}
        </Td>
        <Td className={styles.comment} column="Комментарий">
          <EditableField
            onBlur={changeItemComment.bind(this, cartId)}
            values={{comment: formatCartItemText(comment)}}
            classBtn="text-muted font-italic"
            placeholder="Добавить комментарий"
            name={"comment"}
          />

        </Td>
        <Td column="Поставщик" style={{width: '15%'}}>
          <TableSupplier logo={logo} rating={rating}/>
        </Td>
        {state != 3 && <Td column="Срок, дн." style={{width: '10%'}}>
          {deliveryTerms}
        </Td>}
        {state != 3 && <Td column="Кол-во, шт.">
          <TableItemQuantity
            onChange={changeCartItemQuantity}
            cartDetailId={cartId}
            quantity={quantity}
            limit={offer.quantity}
            partion={partion}
          />

        </Td>}
        <Td className={styles.price} colSpan={state == 3 ? 3 : 1} column="Цена">
          {state != 3 ?
            <div>
              {oldPrice ?
                <div>
                  <div className="text-danger">
                    {fpt(price)}
                  </div>
                  <del> {fpt(oldPrice)}</del>
                </div> :
                fpt(price)
              }

            </div> :
            <div>
              <span className="mr-2">Предложение устарело.</span>
              <Button href={`search?article=${detailArticle}`} size="sm">Найти другое предложение</Button>
            </div>}
        </Td>
        <Td column=" ">
          <div
            onClick={() => removeCartItem(cartId)}
            className={styles.removeIcon}>
            <InlineSVG svg={deleteIcon}/>
          </div>
        </Td>
      </Tr>
    ));
    return (
      <Table className={`table hide-empty-cell ${styles.table}`}>
        {renderTableHeader()}
        {tableRows}
      </Table>
    );
  }
}

export default connect(
  () => ({}),
  (dispatch) => ({actions: bindActionCreators(actions, dispatch)})
)(CartItemsTable);



/** WEBPACK FOOTER **
 ** ./src/components/Cart/elements/CartItemsTable.jsx
 **/